



































import { defineComponent, computed, PropType, ref, toRefs, watch, unref, reactive } from '@nuxtjs/composition-api'
import { whenever } from '@vueuse/core'

import SearchFilter from '@/classes/SearchFilter'
import CarStore from '@/classes/CarStore'
import CustomSelectItem from '@/interfaces/CustomSelectItem'

import useSearchFilter from '@/composables/use-search-filter'
import useShowable from '@/composables/use-showable'
import useSortMethod from '@/composables/use-sort-method'
import useI18n from '@/composables/use-i18n'

import GDialogBody from '@/components/GDialogBody.vue'
import { tdCarFilterMb } from '@/modules/ga4'

export default defineComponent({
  props: {
    value: {
      type: Object as PropType<SearchFilter>,
      default: () => new SearchFilter(),
    },
    priceRangeMinMax: {
      type: Array as PropType<unknown[] | null>,
      default: null,
    },
    carStoreList: {
      type: Array as PropType<CarStore[] | null>,
      default: null,
    },
    availableBrands: {
      type: Array as PropType<CustomSelectItem['value'][]>,
      default: () => [],
    },
    availableCarTypes: {
      type: Array as PropType<CustomSelectItem['value'][]>,
      default: () => [],
    },
  },
  setup (props, { emit }) {
    const {
      sortMethod,
      ageRange,
      priceRange,
      oneWayRental,
      acceptForeigner,
      brands,
      carTypes,
      paymentMethods,
      storeServices,
      equipments,
      filter,
      clear,
    } = useSearchFilter()
    const { isShow, show, hide } = useShowable()
    const saveAndHide = () => {
      save()
      hide()

      tdCarFilterMb({
        sort: getSortMethodName(selected.sortMethod),
        age: selected.ageRange ? selected.ageRange.name : '',
        price_min: selected.priceRange[0]?.toString() ?? '',
        price_max: selected.priceRange[1]?.toString() ?? '',
        license: selected.acceptForeigner ? i18n.t('filter.acceptForeigner.switch.label').toString() : '',
        brand: selected.brands.map(item => item.name).join(','),
        model: selected.carTypes.map(item => item.name).join(','),
        payment: selected.paymentMethods.map(item => i18n.t(item.namePath!).toString()).join(','),
        optional: selected.storeServices.map(item => item.name).join(','),
        equipment: selected.equipments.map(item => item.name).join(','),
      })
    }

    watch(
      [toRefs(props).value, isShow],
      () => {
        if (isShow.value) filter.value = props.value.clone()
      },
      { immediate: true }
    )

    const save = () => emit('input', filter.value.clone())
    const { getSortMethodName, list: sortMethods } = useSortMethod()

    const body = ref<InstanceType<typeof GDialogBody> | null>(null)
    // 重新開啟視窗時滾動至頂部
    whenever(isShow, () => body.value?.scrollToTop())

    const i18n = useI18n()

    const saveButtonText = computed(() => {
      const value = props.carStoreList
        ?.map(carStore => filter.value.test(carStore))
        .filter(Boolean).length ?? 0
      const count = (value && value < 100)
        ? value
        : Math.floor(unref(value) / 100) * 100
      const choice = (unref(value) && count < 100) ? 1 : count
      return i18n.tc('action.applyFilter', choice, [count])
    })

    const selected = reactive({
      sortMethod: SearchFilter.defaultSortMethod,
      ageRange: undefined as CustomSelectItem | undefined,
      priceRange: [] as number[],
      acceptForeigner: false,
      brands: [] as CustomSelectItem[],
      carTypes: [] as CustomSelectItem[],
      paymentMethods: [] as CustomSelectItem[],
      storeServices: [] as CustomSelectItem[],
      equipments: [] as CustomSelectItem[],
    })
    const onUpdate = <K extends keyof typeof selected>(key: K, value: typeof selected[K]) => {
      selected[key] = value
    }

    return {
      isShow,
      show,
      hide,
      saveAndHide,
      clear,

      sortMethod,
      ageRange,
      priceRange,
      oneWayRental,
      acceptForeigner,
      brands,
      carTypes,
      paymentMethods,
      storeServices,
      equipments,

      filter,
      sortMethods,

      body,
      saveButtonText,

      onUpdate,
    }
  },
})
